import Compressor from "compressorjs";
import { STORAGE_KEYS, getFromStorage } from "../helpers";
import { API_URL, END_POINTS } from "../helpers";

interface UploadResponse {
  statusCode: number;
  data: string;
  message: string;
}

export const UploadMedia = (imageObject: any): Promise<UploadResponse> => {
  return new Promise(async (resolve, reject) => {
    new Compressor(imageObject, {
      quality: 0.6,
      success: async (compressedResult) => {
        const formData = new FormData();
        formData.append("image", compressedResult as any);
        // const encryptedFormData = generateEncryptedKeyBody(formData);
        let headers = {
          Accept: "application/json",
        };

        try {
          const res = await fetch(API_URL + "/" + END_POINTS?.mediaUpload, {
            method: "POST",
            headers,
            body: formData,
          });
          let response = await res.json();
          resolve(response); // Resolve the Promise with the response
        } catch (error) {
          console.log(error, ">>>>>>>>>");
          reject(error); // Reject the Promise with the error
        }
      },
    });
  });
};

export const UploadVideo = (mediaObject: File): Promise<UploadResponse> => {
  return new Promise(async (resolve, reject) => {
    const formData = new FormData();
    formData.append("image", mediaObject);

    let headers = {
      Accept: "application/json",
    };
    try {
      const res = await fetch(API_URL + "/" + END_POINTS?.mediaUpload, {
        method: "POST",
        headers,
        body: formData,
      });

      if (res.ok) {
        const response = await res.json();
        resolve(response); // Resolve the Promise with the response
      } else {
        const errorResponse = await res.json();
        reject(errorResponse); // Reject the Promise with the error response
      }
    } catch (error) {
      console.error(error);
      reject(error); // Reject the Promise with the error
    }
  });
};

export const UploadPdf = async (imageObject: any) => {
  const formData = new FormData();
  formData.append("media", imageObject as any);

  const getToken = await getFromStorage(STORAGE_KEYS.token);
  const token = getToken ? JSON.parse(`${getToken}`) : null;
  let headers = {
    // "Content-Type": "multipart/form-data",
    Accept: "application/json",
    Authorization: "Bearer " + token,
  };
  try {
    const res = await fetch(API_URL + "/" + END_POINTS.mediaUpload, {
      method: "POST",
      headers,
      body: formData,
    });
    let response = await res.json();
    return response;
  } catch (error) {
    console.log(error, ">>>>>>>>>");
    return error;
  }
};

//  export const UploadCsv = async (csvObject: any) => {
//   const formData = new FormData();
//   formData.append("file", csvObject as any);
//   const getToken = await getFromStorage(STORAGE_KEYS.token);
//   const token = getToken ? JSON.parse(`${getToken}`) : null;
//   let headers = {
//     // "Content-Type": "multipart/form-data",
//     Accept: "application/json",
//     Authorization: "Bearer " + token,
//   };
//   try {
//     const res = await fetch(API_URL + END_POINTS.mediaUpload, {
//       method: "POST",
//       headers,
//       body: formData,
//     });
//     let response = await res.json();
//     return response;
//   } catch (error) {
//     console.log(error, ">>>>>>>>>");
//     return error;
//   }
// };
